import React, { useState } from "react";
import Logo from "../../../assets/img/logo.png";
import EyeBlock from "../../../assets/img/eye_block.svg";
import EyeOpen from "../../../assets/img/eye_open.svg";
import { SuccessWithButton } from "../../../components/Alert";
import api from "../../../config/api";

function PrivacyPolicy(props) {
  return (
    <>
      <div className="container-fluid mb-5 mb-lg-0  h-100">
        <div className="row h-100 justify-content-center d-flex ">
          <div className="col-lg-8 mt-5">
            <div className="d-flex justify-content-center align-items-center mb-5">
              <img alt="" src={Logo} />
            </div>
            <div>
              <title>Política de Privacidade do aplicativo Reservei</title>
              <h3>Política de Privacidade do aplicativo Reservei</h3>
              <br></br>
              <p>
                O aplicativo Reservei valoriza a sua privacidade e está comprometido em proteger todas as informações
                pessoais coletadas através de sua plataforma. Esta Política de Privacidade descreve como coletamos,
                utilizamos e compartilhamos os dados pessoais do usuário.
              </p>
              <h5>1. Coleta de informações</h5>
              <p>
                O aplicativo Reservei pode coletar informações pessoais, tais como nome, endereço de e-mail, número de
                telefone e outras informações de contato. Também podemos coletar informações de uso do aplicativo, como
                dados de uso, interações com o aplicativo e outras informações técnicas.
              </p>
              <h5>2. Uso das informações</h5>
              <p>
                As informações coletadas pelo aplicativo Reservei serão utilizadas para personalizar a experiência do
                usuário, oferecer conteúdo personalizado e aprimorar os serviços oferecidos. Além disso, as informações
                também podem ser utilizadas para fins de comunicação com o usuário, envio de promoções e atualizações
                sobre o aplicativo.
              </p>
              <h5>3. Compartilhamento das informações</h5>
              <p>
                O aplicativo Reservei não compartilha as informações pessoais do usuário com terceiros sem o
                consentimento expresso do mesmo. No entanto, podemos compartilhar informações anônimas ou agregadas com
                parceiros de negócios e anunciantes.
              </p>
              <h5>4. Segurança das informações</h5>
              <p>
                O aplicativo Reservei adota medidas de segurança para proteger todas as informações coletadas. No
                entanto, não podemos garantir a segurança absoluta das informações pessoais do usuário, já que nenhum
                método de transmissão pela internet é 100% seguro.
              </p>
              <h5>5. Alterações na Política de Privacidade</h5>
              <p>
                O aplicativo Reservei pode atualizar esta Política de Privacidade de tempos em tempos. Todas as
                alterações serão divulgadas no aplicativo e os usuários serão notificados por e-mail ou notificação no
                aplicativo.
              </p>
              <h5>6. Contato</h5>
              <p>
                Se o usuário tiver alguma dúvida ou preocupação sobre esta Política de Privacidade, ele pode entrar em
                contato conosco através do endereço de e-mail: admin@reservei.com.
              </p>
              <br></br>
              <p>
                Ao utilizar o aplicativo Reservei, o usuário concorda com os termos desta Política de Privacidade e
                consente com a coleta, uso e compartilhamento de suas informações pessoais, conforme descrito acima.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
